import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import contractService from '../../services/ContractService';
import "./css/Upload.css";

const ForceUpload = ({ contract,  show, onClose }) => {
    const fileInputRef = useRef();
    const fileProjectInputRef = useRef();
    const { register,setValue, watch } = useForm();

    const [message, setMessage] = useState(null);
    const [errorMsg, setErrorMsg] = useState("Il contratto non presenta i requisiti per passare in stato Accettato, caricare il file firmato. ");
    const [uploadSignedOK, setUploadSignedOK] = useState(false);

    const closeSlide = () => {
        setUploadSignedOK(false);
        setErrorMsg(null);
        setMessage(null);
        onClose();
    };

    const uploadSignedPdf = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append("contractId", contract.id_contract);
        if (contract) {
            contractService.upload(formData)
            .then((res) => {
               setMessage("Cntratto caricato con successo!");
               setErrorMsg("");
               setUploadSignedOK(true);
            }).catch((error) => {
                console.error("Error add file: ", error);
                setMessage("");
                setUploadSignedOK(false);
                setErrorMsg("Errore aggiunta file contratto. Riprova.");
            });
        }
    };

    const handleFileSelect = (file) => {
        if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
            setMessage("");
            setErrorMsg("Sono consentiti solo file PDF, riprova.");
            return;
        }
        if (file.size > 15 * 1024 * 1024) {
            setMessage("");
            setErrorMsg("File troppo grande, supera i 15 MB.");
            return;
        }
        setValue("file", [file]);
        if (file) uploadSignedPdf(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) handleFileSelect(file);
    };
    const handleProjectDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) handleFileSelect(file);
    };

    const handleClick = () => fileInputRef.current.click();
    const file = watch("file")?.[0];

    return (
        <>
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Carica i file per il contratto {contract ? contract.number.toString().padStart(3, "0") : ""}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <div className="row">
                    <div className="col-12">
                        <div className="card-body p-4">
                            <form className="dropzone" onSubmit={(e) => e.preventDefault()}>
                                <div className="dz-message" onClick={handleClick} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
                                    Trascina il file contratto qui o clicca per caricarlo
                                    <input type="file"
                                        {...register("file", { required: true })}
                                        ref={(e) => {
                                            register("file").ref(e);
                                            fileInputRef.current = e;
                                        }}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                handleFileSelect(e.target.files[0]);
                                            }
                                        }}
                                        accept=".pdf"
                                        style={{ display: "none" }}
                                    />
                                </div>
                                {uploadSignedOK &&
                                    <div className="dz-preview">
                                        <div className="dz-thumbnail alert-outline-success"></div>
                                        <div className="dz-filename">{file ? file.name : ""}</div>
                                        <div className="dz-size"><strong>{file ? (file.size / (1024 * 1024)).toFixed(2) : ""}</strong> MB</div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>

    );
};

export default ForceUpload;